export function getDaysAgo(isoDate: string) {
  const created = new Date(isoDate).getTime();
  const diffMs = Date.now() - created;
  return Math.max(0, Math.floor(diffMs / (1000 * 60 * 60 * 24)));
}

export function formatCreatedAgo(isoDate: string) {
  const days = getDaysAgo(isoDate);
  if (days === 0) return "Created today";
  return `Created ${days} ${days === 1 ? "day" : "days"} ago`;
}
